"use client";

import { createContext, useContext } from "react";

export type TranscriptTheme = "light" | "dark" | "color";

interface TranscriptSettingsContextType {
  theme: TranscriptTheme;
  colorHex: string;
  fontMultiplier: number;
  isAutoScrollEnabled: boolean;
}

const TranscriptSettingsContext = createContext<
  TranscriptSettingsContextType | undefined
>(undefined);

export const useTranscriptSettings = () => {
  const context = useContext(TranscriptSettingsContext);
  if (!context) {
    throw new Error(
      "useTranscriptSettings must be used within a TranscriptSettingsProvider",
    );
  }
  return context;
};

export const TranscriptSettingsProvider: React.FC<
  TranscriptSettingsContextType & { children: React.ReactNode }
> = ({ theme, colorHex, fontMultiplier, isAutoScrollEnabled, children }) => (
  <TranscriptSettingsContext.Provider
    value={{ theme, colorHex, fontMultiplier, isAutoScrollEnabled }}
  >
    {children}
  </TranscriptSettingsContext.Provider>
);
